/**
 * 会员管理
 * */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TabType } from './types';
import { connect } from 'react-redux';
import styles from './index.module.scss';
import { XTabNav } from '@/components/xqxc_ui';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import User from './user/main';
import Company from './company/main';

const tabList = [
    { id: TabType.User, label: '用户' },
    { id: TabType.Company, label: '企业' },
];

const OCTabList = [
    { id: TabType.Company, label: '企业' },
]

const Member = (props) => {

    const [curTabID, setCurTabID] = useState(process.env.TYPE == 'OC' ? TabType.Company : sessionStorage.getItem('user-member') || TabType.User);

    useEffect(() => {
        sessionStorage.getItem('user-member') && sessionStorage.removeItem('user-member');
        props.setBreadcrumbPaths(props.match);
    }, []);


    return (
        <div className={styles.flexBoxContainer}>
            <XTabNav renderData={process.env.TYPE == 'OC' ? OCTabList : tabList} onChange={setCurTabID} activedID={curTabID} />
            <div className={styles.TabContentBox}>
                {curTabID === TabType.User && <User key={curTabID} curTabID={curTabID} {...props} />}
                {curTabID === TabType.Company && <Company key={curTabID} curTabID={curTabID}  {...props} />}
            </div>
        </div>
    );
};

Member.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,//路由对象
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(Member);